import { useRef, useState } from "react";
import { useMotionValueEvent } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { T } from "./HeroIntro";

const KEY = "jc_hero_sound";

const playBreak = (ctx) => {
  const now = ctx.currentTime;
  const len = Math.floor(ctx.sampleRate * 0.35);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 4);
  const noise = ctx.createBufferSource();
  noise.buffer = buf;
  const bp = ctx.createBiquadFilter();
  bp.type = "bandpass"; bp.frequency.value = 1800; bp.Q.value = 0.8;
  const ng = ctx.createGain();
  ng.gain.setValueAtTime(0.5, now);
  ng.gain.exponentialRampToValueAtTime(0.001, now + 0.35);
  noise.connect(bp).connect(ng).connect(ctx.destination);
  noise.start(now);
  [1568, 2093, 2637, 3136, 2349, 3520, 2794].forEach((f, i) => {
    const t = now + 0.08 + i * 0.07 + Math.random() * 0.03;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine"; o.frequency.value = f;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.09, t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    o.connect(g).connect(ctx.destination);
    o.start(t); o.stop(t + 0.55);
  });
};

export const HeroSound = ({ p }) => {
  const { tr } = useLang();
  const [on, setOn] = useState(() => localStorage.getItem(KEY) === "on");
  const ctx = useRef(null);
  const last = useRef(0);
  const getCtx = () => (ctx.current ||= new (window.AudioContext || window.webkitAudioContext)());

  useMotionValueEvent(p, "change", (v) => {
    if (on && last.current < T.hit && v >= T.hit) { const c = getCtx(); c.resume(); playBreak(c); }
    last.current = v;
  });

  const toggle = () => {
    const next = !on;
    setOn(next);
    localStorage.setItem(KEY, next ? "on" : "off");
    if (next) getCtx().resume();
  };

  const Icon = on ? Volume2 : VolumeX;
  return (
    <button onClick={toggle} aria-pressed={on} aria-label={on ? tr("Ton aus", "Sound off") : tr("Ton an", "Sound on")} data-testid="hero-sound-toggle"
      className="absolute bottom-6 right-4 sm:right-8 z-40 inline-flex items-center gap-2 rounded-full border border-[#C9B6F2]/30 bg-[#120E1F]/60 backdrop-blur-md px-3.5 py-2 text-[11px] uppercase tracking-[0.2em] text-[#C9B6F2] hover:border-[#F2C230]/70 hover:text-[#F2C230] transition-colors">
      <Icon className="h-4 w-4" />{on ? tr("Ton an", "Sound on") : tr("Ton aus", "Sound off")}
    </button>
  );
};
